import Vue from "vue";
import Vuex from "vuex";
import Auth from "./Auth";
import Scheduler from "./Scheduler";
import Setup from "./Setup";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		Auth,
		Scheduler,
		Setup
	},
	plugins: [createPersistedState()]
});